/* Rendering only. Cart/builder owners pass a real cart; no shipping rule or cart mutation is performed here. */
(function () {
  'use strict';
  if (window.Top1BundleShipping) return;
  window.Top1BundleShipping = {
    rule: function (root) {
      return { verified: root.dataset.shippingVerified === 'true', threshold: window.Top1BundleCore.int(root.dataset.shippingThreshold, 0), currency: root.dataset.shippingCurrency, country: root.dataset.shippingCountry };
    },
    render: function (root, options) {
      var core = window.Top1BundleCore, rule = this.rule(root);
      var result = core.shippingProgress(options.cart, rule, options.currency, options.country, options.projectedTotal);
      root.hidden = !result.enabled;
      var nudge = root.querySelector('[data-shipping-nudge]');
      nudge.hidden = true;
      if (!result.enabled) return result;
      var money = function (value) { return (core.formatPrice || core.formatMoney)(value, options.currency, options.locale); };
      var bar = root.querySelector('[data-shipping-bar]');
      bar.max = result.threshold; bar.value = Math.min(result.total, result.threshold);
      bar.setAttribute('aria-label', (result.estimated ? 'Estimated order' : 'Cart merchandise') + ' towards free standard delivery');
      bar.setAttribute('aria-valuetext', money(result.total) + ' of ' + money(result.threshold));
      var message = root.querySelector('[data-shipping-message]'), rule = ' (orders of ' + money(result.threshold) + ' or more).';
      if (result.reached) message.textContent = (result.estimated ? 'With this pack, your order gets free standard delivery' : 'Your order gets free standard delivery') + rule;
      else message.textContent = 'Spend ' + money(result.remaining) + ' more for free standard delivery' + rule;
      if (options.nudge && result.estimated && !result.reached) {
        var pairs = options.nudge.extraPairs || Math.max(1, options.nudge.quantity - (options.quantity || 0));
        nudge.hidden = false; nudge.disabled = !!options.busy;
        nudge.dataset.bbShippingQuantity = options.nudge.quantity;
        nudge.textContent = 'Add ' + pairs + ' more ' + (options.nudge.name ? options.nudge.name + ' ' : '') + 'pair' + (pairs === 1 ? '' : 's') + ' for ' + money(options.nudge.extraCost) + ' and delivery is free';
      }
      return result;
    }
  };
})();
